export enum AddPageButton {
  Main = 'buttom',
  Header = 'top',
}
